import type { DeepPartial } from '@luna/utils-ts';

import type { KycFeatureConfig } from '../type';

export const kyc: DeepPartial<KycFeatureConfig> = {
    handoverTargetClientId: 'SYDC6954',
    oidcReady: false,
    passParamsInQuery: true,
    preferTokenExchange: true,
    passCurrentAccessToken: false,
    handoffModePaths: { required: 'edit', optional: 'view' },
    handoffModeQueryParams: { required: {}, optional: {} },
};
